export const environment = {
  production: true,
  msUrl: "https://ms.gov.ge",
  jsonURL: 'assets/data/municipalities/municipalities.json',
  ssoUrl:'https://sso.municipal.gov.ge',
  municip: [
    [
      'ა',
      [
        {
          name: 'აბაშის მუნიციპალიტეტი',
          flag: 'Abasha.png',
          clientId: 2731,
          code: 'Abasha-city-hall-id',
          disabled: false
        },
        {
          name: 'ადიგენის მუნიციპალიტეტი',
          flag: 'Adigeni.png',
          clientId: 5367,
          code: '',
          disabled: false
        },
        {
          name: 'ამბროლაურის მუნიციპალიტეტი',
          flag: 'Ambrolauri.png',
          clientId: 2755,
          code: '',
          disabled: false
        },
        {
          name: 'ასპინძის მუნიციპალიტეტი',
          flag: 'Aspindza.png',
          clientId: 5375,
          code: '',
          disabled: false
        },
        {
          name: 'ახალქალაქის მუნიციპალიტეტი',
          flag: 'Akhalkalaki.png',
          clientId: 5371,
          code: '',
          disabled: false
        },
        {
          name: 'ახალციხის მუნიციპალიტეტი',
          flag: 'Akhaltsikhe.png',
          clientId: 2740,
          code: 'Akhaltsikhe-city-hall-id',
          disabled: false
        },
        {
          name: 'ახმეტის მუნიციპალიტეტი',
          flag: 'Akhmeta.png',
          clientId: 4096,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ბ',
      [
        {
          name: 'თვითმმართველი ქალაქი ბათუმი',
          flag: 'Batumi.png',
          clientId: 2715,
          code: 'batumi-city-hall-id',
          disabled: false
        },
        {
          name: 'ბაღდათის მუნიციპალიტეტი',
          flag: 'Bagdati.png',
          clientId: 4113,
          code: '',
          disabled: false
        },
        {
          name: 'ბოლნისის მუნიციპალიტეტი',
          flag: 'Bolnisi.png',
          clientId: 5361,
          code: '',
          disabled: false
        },
        {
          name: 'ბორჯომის მუნიციპალიტეტი',
          flag: 'Borjomi.png',
          clientId: 2742,
          code: 'Borjomi-city-hall-id',
          disabled: false
        }
      ]
    ],
    [
      'გ',
      [
        {
          name: 'გარდაბნის მუნიციპალიტეტი',
          flag: 'Gardabani.png',
          clientId: 2752,
          code: 'Gardabani-city-hall-id',
          disabled: false
        },
        {
          name: 'გორის მუნიციპალიტეტი',
          flag: 'Gori.png',
          clientId: 2744,
          code: 'Gori-city-hall-id',
          disabled: false
        },
        {
          name: 'გურჯანიის მუნიციპალიტეტი',
          flag: 'Gurjaani.png',
          clientId: 4092,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'დ',
      [
        {
          name: 'დედოფლისწყაროს მუნიციპალიტეტი',
          flag: 'Dedoplistsqaro.png',
          clientId: 4123,
          code: '',
          disabled: false
        },
        {
          name: 'დმანისის მუნიციპალიტეტი',
          flag: 'Dmanisi.png',
          clientId: 5363,
          code: '',
          disabled: false
        },
        {
          name: 'დუშეთის მუნიციპალიტეტი',
          flag: 'Dusheti.png',
          clientId: 5387,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ვ',
      [
        {
          name: 'ვანის მუნიციპალიტეტი',
          flag: 'Vani.png',
          clientId: 4115,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ზ',
      [
        {
          name: 'ზესტაფონის მუნიციპალიტეტი',
          flag: 'Zestaponi.png',
          clientId: 2738,
          code: 'Zestafoni-city-hall-id  ',
          disabled: false
        },
        {
          name: 'ზუგდიდის მუნიციპალიტეტი',
          flag: 'Zugdidi.png',
          clientId: 2725,
          code: 'zugdidi-city-hall-id',
          disabled: false
        }
      ]
    ],
    [
      'თ',
      [
        {
          name: 'ქალაქ თბილისის მუნიციპალიტეტი',
          flag: 'Tbilisi.png',
          clientId: 41,
          code: 'tbilisi-city-hall-id',
          disabled: false
        },
        {
          name: 'თეთრიწყაროს მუნიციპალიტეტი',
          flag: 'tetriwyaro.png',
          clientId: 5379,
          code: '',
          disabled: false
        },
        {
          name: 'თელავის მუნიციპალიტეტი',
          flag: 'Telavi.png',
          clientId: 102,
          code: '',
          disabled: false
        },
        {
          name: 'თერჯოლის მუნიციპალიტეტი',
          flag: 'Terjola.png',
          clientId: 2736,
          code: 'Terjola-city-hall-id',
          disabled: false
        },
        {
          name: 'თიანეთის მუნიციპალიტეტი',
          flag: 'Tianeti.png',
          clientId: 5385,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'კ',
      [
        {
          name: 'კასპის მუნიციპალიტეტი',
          flag: 'Kaspi.png',
          clientId: 4100,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ლ',
      [
        {
          name: 'ლაგოდეხის მუნიციპალიტეტი',
          flag: 'Lagodekhi.png',
          clientId: 4090,
          code: '',
          disabled: false
        },
        {
          name: 'ლანჩხუთის მუნიციპალიტეტი',
          flag: 'Lanchkhuti.png',
          clientId: 2719,
          code: 'lanchkhuti-city-hall-id',
          disabled: false
        },
        {
          name: 'ლენტეხის მუნიციპალიტეტი',
          flag: 'Lentekhi.png',
          clientId: 5351,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'მ',
      [
        {
          name: 'მარნეულის მუნიციპალიტეტი',
          flag: 'Marneuli.png',
          clientId: 2750,
          code: 'Marneuli-city-hall-id',
          disabled: false
        },
        {
          name: 'მარტვილის მუნიციპალიტეტი',
          flag: 'Martvili.png',
          clientId: 4121,
          code: '',
          disabled: false
        },
        {
          name: 'მესტიის მუნიციპალიტეტი',
          flag: 'Mestia.png',
          clientId: 5389,
          code: '',
          disabled: false
        },
        {
          name: 'მცხეთის მუნიციპალიტეტი',
          flag: 'Mtskheta.png',
          clientId: 2746,
          code: 'Mtskheta-city-hall-id',
          disabled: false
        }
      ]
    ],
    [
      'ნ',
      [
        {
          name: 'ნინოწმინდის მუნიციპალიტეტი',
          flag: 'Ninotsminda.png',
          clientId: 5377,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ო',
      [
        {
          name: 'ოზურგეთის მუნიციპალიტეტი',
          flag: 'Ozurgeti.png',
          clientId: 2717,
          code: 'ozurgeti-city-hall-id',
          disabled: false
        },
        {
          name: 'ონის მუნიციპალიტეტი',
          flag: 'Oni.png',
          clientId: 4104,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'რ',
      [
        {
          name: 'თვითმმართველი ქალაქი რუსთავი',
          flag: 'Rustavi.png',
          clientId: 2748,
          code: 'Rustavi-city-hall-id',
          disabled: false
        }
      ]
    ],
    [
      'ს',
      [
        {
          name: 'საგარეჯოს მუნიციპალიტეტი',
          flag: 'Sagarejo.png',
          clientId: 4127,
          code: '',
          disabled: false
        },
        {
          name: 'სამტრედიის მუნიციპალიტეტი',
          flag: 'Samtredia.png',
          clientId: 4117,
          code: '',
          disabled: false
        },
        {
          name: 'საჩხერის მუნიციპალიტეტი',
          flag: 'Sachkhere.png',
          clientId: 4110,
          code: '',
          disabled: false
        },
        {
          name: 'სენაკის მუნიციპალიტეტი',
          flag: 'Senaki.png',
          clientId: 2729,
          code: 'Senaki-city-hall-id',
          disabled: false
        },
        {
          name: 'სიღნაღის მუნიციპალიტეტი',
          flag: 'Signagi.png',
          clientId: 4125,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ტ',
      [
        {
          name: 'ტყიბულის მუნიციპალიტეტი',
          flag: 'Tkibuli.png',
          clientId: 4105,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ფ',
      [
        {
          name: 'თვითმმართველი ქალაქი ფოთი',
          flag: 'Poti.png',
          clientId: 2723,
          code: 'poti-city-hall-id',
          disabled: false
        }
      ]
    ],
    [
      'ქ',
      [
        {
          name: 'ქარელის მუნიციპალიტეტი',
          flag: 'Kareli.png',
          clientId: 5359,
          code: '',
          disabled: false
        },
        {
          name: 'ქედის მუნიციპალიტეტი',
          flag: 'Kedi.png',
          clientId: 5349,
          code: '',
          disabled: false
        },
        {
          name: 'ქობულეთის მუნიციპალიტეტი',
          flag: 'Kobuleti.png',
          clientId: 5369,
          code: '',
          disabled: false
        },
        {
          name: 'თვითმმართველი ქალაქი ქუთაისი',
          flag: 'Kutaisi.png',
          clientId: 110,
          code: 'quteisi',
          disabled: false
        }
      ]
    ],
    [
      'ყ',
      [
        {
          name: 'ყაზბეგის მუნიციპალიტეტი',
          flag: 'Kazbegi.png',
          clientId: 5357,
          code: '',
          disabled: false
        },
        {
          name: 'ყვარლის მუნიციპალიტეტი',
          flag: 'Kvareli.png',
          clientId: 4094,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'შ',
      [
        {
          name: 'შუახევის მუნიციპალიტეტი',
          flag: 'Shuakhevi.png',
          clientId: 5355,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ჩ',
      [
        {
          name: 'ჩოხატაურის მუნიციპალიტეტი',
          flag: 'Chokhatauri.png',
          clientId: 2721,
          code: 'chokhatauri-city-hall-id',
          disabled: false
        },
        {
          name: 'ჩხოროწყუს მუნიციპალიტეტი',
          flag: 'Chkhorotsku.png',
          clientId: 5365,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ც',
      [
        {
          name: 'ცაგერის მუნიციპალიტეტი',
          flag: 'Tsageri.png',
          clientId: 4102,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'წ',
      [
        {
          name: 'წალენჯიხის მუნიციპალიტეტი',
          flag: 'Tsalenjikha.png',
          clientId: 5381,
          code: '',
          disabled: false
        },
        {
          name: 'წალკის მუნიციპალიტეტი',
          flag: 'Tsalka.png',
          clientId: 5373,
          code: '',
          disabled: false
        },
        {
          name: 'წყალტუბოს მუნიციპალიტეტი',
          flag: 'Tskhaltubo.png',
          clientId: 2734,
          code: 'Tskaltubo-city-hall-id',
          disabled: false
        }
      ]
    ],
    [
      'ჭ',
      [
        {
          name: 'ჭიათურის მუნიციპალიტეტი',
          flag: 'Chiatura.png',
          clientId: 4108,
          code: '',
          disabled: false
        }
      ]
    ],
    [
      'ხ',
      [
        {
          name: 'ხარაგაულის მუნიციპალიტეტი',
          flag: 'Kharagauli.png',
          clientId: 4112,
          code: '',
          disabled: false
        },
        {
          name: 'ხაშურის მუნიციპალიტეტი',
          flag: 'Khashuri.png',
          clientId: 4098,
          code: '',
          disabled: false
        },
        {
          name: 'ხელვაჩაურის მუნიციპალიტეტი',
          flag: 'khelvachauri.png',
          clientId: 5383,
          code: '',
          disabled: false
        },
        {
          name: 'ხობის მუნიციპალიტეტი',
          flag: 'Khobi.png',
          clientId: 2727,
          code: 'Khobi-city-hall-id',
          disabled: false
        },
        {
          name: 'ხონის მუნიციპალიტეტი',
          flag: 'Khoni.png',
          clientId: 4119,
          code: '',
          disabled: false
        },
        {
          name: 'ხულოს მუნიციპალიტეტი',
          flag: 'Khulo.png',
          clientId: 5353,
          code: '',
          disabled: false
        }
      ]
    ]
  ],
  apiUlr: 'https://api.municipal.gov.ge'
};



// WEBPACK FOOTER //
// /opt/app-root/src/src/environments/environment.ts